import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/UserDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class UserEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/user/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class UserFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public selected: IFieldOptions = { field: "selected" };
	public displayName: IFieldOptions = { field: "displayName" };
	public defaultOrganisationId: IFieldOptions = { field: "defaultOrganisationId" };
	public userName: IFieldOptions = { field: "userName" };
	public email: IFieldOptions = { field: "email" };
	public emailConfirmed: IFieldOptions = { field: "emailConfirmed" };
	public accessFailedCount: IFieldOptions = { field: "accessFailedCount" };
	public concurrencyStamp: IFieldOptions = { field: "concurrencyStamp" };
	public lockoutEnabled: IFieldOptions = { field: "lockoutEnabled" };
	public lockoutEnd: IFieldOptions = { field: "lockoutEnd" };
	public normalizedEmail: IFieldOptions = { field: "normalizedEmail" };
	public normalizedUserName: IFieldOptions = { field: "normalizedUserName" };
	public passwordHash: IFieldOptions = { field: "passwordHash" };
	public phoneNumber: IFieldOptions = { field: "phoneNumber" };
	public phoneNumberConfirmed: IFieldOptions = { field: "phoneNumberConfirmed" };
	public securityStamp: IFieldOptions = { field: "securityStamp" };
	public twoFactorEnabled: IFieldOptions = { field: "twoFactorEnabled" };
	public isSuperAdmin: IFieldOptions = { field: "isSuperAdmin" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public status: IFieldOptions = { field: "status" };
	public passwordExpiryEnabled: IFieldOptions = { field: "passwordExpiryEnabled" };
	public passwordExpiryDatestamp: IFieldOptions = { field: "passwordExpiryDatestamp" };
	public typeId: IFieldOptions = { field: "typeId" };
	public firstname: IFieldOptions = { field: "firstname" };
	public lastname: IFieldOptions = { field: "lastname" };
	public dob: IFieldOptions = { field: "dob" };
	public sisproPrefix: IFieldOptions = { field: "sisproPrefix" };
	public password: IFieldOptions = { field: "password" };
  public confirmPassword: IFieldOptions = { field: "confirmPassword" };
  public signatureFileCabinetId: IFieldOptions = { field: "signatureFileCabinetId" }; 
	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.displayName);
		this.push(this.defaultOrganisationId);
		this.push(this.userName);
		this.push(this.email);
		this.push(this.emailConfirmed);
		this.push(this.accessFailedCount);
		this.push(this.concurrencyStamp);
		this.push(this.lockoutEnabled);
		this.push(this.lockoutEnd);
		this.push(this.normalizedEmail);
		this.push(this.normalizedUserName);
		this.push(this.passwordHash);
		this.push(this.phoneNumber);
		this.push(this.phoneNumberConfirmed);
		this.push(this.securityStamp);
		this.push(this.twoFactorEnabled);
		this.push(this.isSuperAdmin);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
		this.push(this.passwordExpiryEnabled);
		this.push(this.passwordExpiryDatestamp);
		this.push(this.typeId);
		this.push(this.firstname);
		this.push(this.lastname);
		this.push(this.dob);
		this.push(this.sisproPrefix);
		this.push(this.password);
      this.push(this.confirmPassword);
      this.push(this.signatureFileCabinetId);
	}
}

export class UserForm implements IFormOptions {
	protected userFormName: string = "userForm";
	protected userFormModel: models.UserDTO = new models.UserDTO();
	protected userFormEndPoints: UserEndPoints = new UserEndPoints();
	protected userFormFields: UserFormFields = new UserFormFields();
	public get name(): string { return this.userFormName };
	public get model(): models.UserDTO { return this.userFormModel };
	public get endPoints(): IEntityEndPoints { return this.userFormEndPoints };
       public set endPoints(userEndPoints: IEntityEndPoints) {
		this.userFormEndPoints = userEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): UserFormFields { return this.userFormFields };
}

export class UserListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public selected: IColumnOptions = { field: "selected" };
	public displayName: IColumnOptions = { field: "displayName" };
	public defaultOrganisationId: IColumnOptions = { field: "defaultOrganisationId" };
	public userName: IColumnOptions = { field: "userName" };
	public email: IColumnOptions = { field: "email" };
	public emailConfirmed: IColumnOptions = { field: "emailConfirmed" };
	public accessFailedCount: IColumnOptions = { field: "accessFailedCount" };
	public concurrencyStamp: IColumnOptions = { field: "concurrencyStamp" };
	public lockoutEnabled: IColumnOptions = { field: "lockoutEnabled" };
	public lockoutEnd: IColumnOptions = { field: "lockoutEnd", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public normalizedEmail: IColumnOptions = { field: "normalizedEmail" };
	public normalizedUserName: IColumnOptions = { field: "normalizedUserName" };
	public passwordHash: IColumnOptions = { field: "passwordHash" };
	public phoneNumber: IColumnOptions = { field: "phoneNumber" };
	public phoneNumberConfirmed: IColumnOptions = { field: "phoneNumberConfirmed" };
	public securityStamp: IColumnOptions = { field: "securityStamp" };
	public twoFactorEnabled: IColumnOptions = { field: "twoFactorEnabled" };
	public isSuperAdmin: IColumnOptions = { field: "isSuperAdmin" };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public status: IColumnOptions = { field: "status" };
	public passwordExpiryEnabled: IColumnOptions = { field: "passwordExpiryEnabled" };
	public passwordExpiryDatestamp: IColumnOptions = { field: "passwordExpiryDatestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public typeId: IColumnOptions = { field: "typeId" };
	public firstname: IColumnOptions = { field: "firstname" };
	public lastname: IColumnOptions = { field: "lastname" };
	public dob: IColumnOptions = { field: "dob", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public sisproPrefix: IColumnOptions = { field: "sisproPrefix" };
	public password: IColumnOptions = { field: "password" };
  public confirmPassword: IColumnOptions = { field: "confirmPassword" };
  public signatureFileCabinetId: IFieldOptions = { field: "signatureFileCabinetId" }; 
	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.displayName);
		this.push(this.defaultOrganisationId);
		this.push(this.userName);
		this.push(this.email);
		this.push(this.emailConfirmed);
		this.push(this.accessFailedCount);
		this.push(this.concurrencyStamp);
		this.push(this.lockoutEnabled);
		this.push(this.lockoutEnd);
		this.push(this.normalizedEmail);
		this.push(this.normalizedUserName);
		this.push(this.passwordHash);
		this.push(this.phoneNumber);
		this.push(this.phoneNumberConfirmed);
		this.push(this.securityStamp);
		this.push(this.twoFactorEnabled);
		this.push(this.isSuperAdmin);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
		this.push(this.passwordExpiryEnabled);
		this.push(this.passwordExpiryDatestamp);
		this.push(this.typeId);
		this.push(this.firstname);
		this.push(this.lastname);
		this.push(this.dob);
		this.push(this.sisproPrefix);
		this.push(this.password);
      this.push(this.confirmPassword);
      this.push(this.signatureFileCabinetId);
	}
}

export class UserList implements IGridOptions {
	protected userListName: string = "userList";
	protected userListModel: models.UserDTO = new models.UserDTO();
	protected userListEndPoints: UserEndPoints = new UserEndPoints();
	protected userListColumns: UserListColumns = new UserListColumns();
	public userForm: UserForm = new UserForm();
	public get name(): string { return this.userListName };
	public get model(): models.UserDTO { return this.userListModel };
	public get endPoints(): IEntityEndPoints { return this.userListEndPoints };
	public set endPoints(userEndPoints: IEntityEndPoints) {
		this.userListEndPoints = userEndPoints;
		this.userForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): UserListColumns { return this.userListColumns };
}

export class UserEntity implements IEntityOptions {
	protected userEntityName: string = "userEntity";
	protected userEntityModel: models.UserDTO = new models.UserDTO();
	protected userEntityEndPoints: UserEndPoints = new UserEndPoints();
	protected userEntityList: UserList = new UserList();
	public get name(): string { return this.userEntityName };
	public get model(): models.UserDTO { return this.userEntityModel };
	public get endPoints(): IEntityEndPoints { return this.userEntityEndPoints };
	public set endPoints(userEndPoints: IEntityEndPoints) {
		this.userEntityEndPoints = userEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): UserList { return this.userEntityList };
	public get form(): UserForm { return this.grid.userForm };
	constructor(name?: string) {
		if (name) this.userEntityName = name;
		this.endPoints = this.userEntityEndPoints;
	}
};
//export class UserGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: UserForm = new UserForm();
//};

//export class UserListPageComponent extends ListPageComponent {
  //protected listPageComponentList: UserList = new  UserList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class UserBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: UserGeneratedForm}];
//};

//export class UserListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: UserListPageComponent, isMenuHidden: true }];
//};

